//MUI components
import { Box, Typography, Link } from "@mui/material";

//images
import quienesSomos from "../../assets/images/quienesSomos.jpg";
import mision from "../../assets/images/mision.jpeg";
import valores from "../../assets/images/Valores.jpg";
import calidad from "../../assets/images/calidad.jpg";

//My Components
import OptionsTab from "../../components/optionsBar";
import { Header } from "../../components/header";
import { WorkspacePremium } from "@mui/icons-material";
import { Footer } from "../../components/footer";

import { useTranslation } from "react-i18next";

function Nosotros() {
  const {t} = useTranslation()

  return (
    <>
      <Header color={"#F0F0F0"} />
      <Box
        style={{
          marginTop: "10rem",
          marginBottom: "5rem",
        }}
      >
        <Typography
          style={{
            color: "#1B2466",
            fontFamily: "Montserrat",
            fontSize: "50px",
            fontStyle: "normal",
            fontWeight: "800",
            lineHeight: "52%",
            textAlign: "center",
            letterSpacing: "-0.1px",
          }}
        >
          {t("nosotros_titulo")}
        </Typography>
      </Box>

      <OptionsTab
        labels={[
          t("quienes_somos"),
          t("exp_mision"),
          t("vision_valores"),
          t("calidad"),
        ]}
      >
        {/* Quienes Somos */}
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 4 }}>
          {/* Columna izquierda: texto */}
          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontWeight: "400",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
                marginBottom: "1rem",
              }}
            >
              {t("quienes_somos_parrafo1")}
            </Typography>

            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontWeight: "400",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
                marginBottom: "1rem",
              }}
            >
              {t("quienes_somos_parrafo2")}
            </Typography>

            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontWeight: "400",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
              }}
            >
              {t("quienes_somos_parrafo3")}
            </Typography>
          </Box>

          {/* Columna derecha: imagen */}
          <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            <Box
              component="img"
              src={quienesSomos}
              alt="imagen"
              sx={{
                width: "100%", // ocupa todo el ancho disponible de su columna
                maxWidth: "700px", // límite para que no sea gigante
                height: "auto", // mantiene proporciones
                objectFit: "cover", // que quede prolija
                borderRadius: 5, // opcional: bordes redondeados
                boxShadow: 3, // opcional: sombra sutil
              }}
            />
          </Box>
        </Box>

        {/* Experiencia y Mision */}
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 4 }}>
          {/* Columna izquierda: texto */}
          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "800",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
              }}
            >
              {t("exp_titulo")}
            </Typography>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
                marginBottom: "1rem",
              }}
            >
              {t("exp_parrafo")}
            </Typography>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "800",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
              }}
            >
              {t("mision_titulo")}
            </Typography>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
              }}
            >
              {t("mision_parrafo")}
            </Typography>
          </Box>
          <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            <Box
              component="img"
              src={mision}
              alt="imagen"
              sx={{
                width: "100%", // ocupa todo el ancho disponible de su columna
                maxWidth: "700px", // límite para que no sea gigante
                height: "auto", // mantiene proporciones
                objectFit: "cover", // que quede prolija
                borderRadius: 5, // opcional: bordes redondeados
                boxShadow: 3, // opcional: sombra sutil
              }}
            />
          </Box>
        </Box>

        {/* Vision y valores */}
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 4 }}>
          {/* Columna izquierda: texto */}
          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
              }}
            >
              {t("vision_titulo")}
            </Typography>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
                marginBottom: "1rem",
              }}
            >
              {t("vision_parrafo")}
            </Typography>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
                marginBottom: "1rem"
              }}
            >
              {t("valores_titulo")}
            </Typography>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
                marginBottom: "1rem",
              }}
            >
              {t("valores")}
            </Typography>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
                marginBottom: "1rem",
              }}
            >
              {t("valores_parrafo1")}
            </Typography>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
              }}
            >
              {t("valores_parrafo2")}
            </Typography>
          </Box>
          <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            <Box
              component="img"
              src={valores}
              alt="imagen"
              sx={{
                width: "100%", // ocupa todo el ancho disponible de su columna
                maxWidth: "700px", // límite para que no sea gigante
                height: "auto", // mantiene proporciones
                objectFit: "cover", // que quede prolija
                borderRadius: 5, // opcional: bordes redondeados
                boxShadow: 3, // opcional: sombra sutil
              }}
            />
          </Box>
        </Box>

        {/* Calidad */}
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 4 }}>
          {/* Columna izquierda: texto */}
          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
                marginBottom: "1rem",
              }}
            >
              {t("calidad_parrafo1")}
            </Typography>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
                marginBottom: "1rem",
              }}
            >
              {t("calidad_parrafo2")}
            </Typography>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
                marginBottom: "1rem",
              }}
            >
              {t("calidad_parrafo3")}
            </Typography>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "171.429%",
                letterSpacing: "-0.134px",
              }}
            >
              {t("calidad_parrafo4")}
            </Typography>
            <Box sx={{ display: "flex" }}>
              <Link
                href="https://ema.com.ar/sitio//wp-content/uploads/2023/05/ISO9001.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Box sx={{ marginRight: "2rem", display: "flex" }}>
                  <WorkspacePremium
                    sx={{ color: "#1B2466", marginTop: "1rem" }}
                  />
                  <Typography
                    sx={{
                      width: "100%",
                      marginTop: "1rem",
                      color: "#1B2466",
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "15px",
                      fontStyle: "normal",
                      fontWeight: "600",
                      lineHeight: "142.857%",
                      letterSpacing: "-0.133px",
                      textDecoration: "underline",
                    }}
                  >
                    {t("certificado_iso")}
                  </Typography>
                </Box>
              </Link>
              <Link
                href="https://ema.com.ar/sitio//wp-content/uploads/2023/05/Politicas-de-gestion.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Box sx={{ display: "flex" }}>
                  <WorkspacePremium
                    sx={{ color: "#1B2466", marginTop: "1rem" }}
                  />
                  <Typography
                    sx={{
                      width: "100%",
                      marginTop: "1rem",
                      color: "#1B2466",
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "15px",
                      fontStyle: "normal",
                      fontWeight: "600",
                      lineHeight: "142.857%",
                      letterSpacing: "-0.133px",
                      textDecoration: "underline",
                    }}
                  >
                    {t("politicas_de_gestion")}
                  </Typography>
                </Box>
              </Link>
            </Box>
          </Box>
          <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            <Box
              component="img"
              src={calidad}
              alt="imagen"
              sx={{
                width: "100%", // ocupa todo el ancho disponible de su columna
                maxWidth: "700px", // límite para que no sea gigante
                height: "auto", // mantiene proporciones
                objectFit: "cover", // que quede prolija
                borderRadius: 5, // opcional: bordes redondeados
                boxShadow: 3, // opcional: sombra sutil
              }}
            />
          </Box>
        </Box>
      </OptionsTab>

      <Box sx={{ marginTop: "5rem" }}>
        <Footer />
      </Box>
    </>
  );
}

export default Nosotros;
